/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type { ThemeType } from "@packages/ui";
import {
  cssMediaQueryMinWidthTablet,
  numericPixels,
  radius,
  spacing,
  zIndices,
} from "@packages/ui";
import Image from "next/image";
import type { ReactNode } from "react";

import bgImg from "../jesus-clouds.webp";
import { MobileDownloadLinksClient } from "./MobileDownloadLinksClient";

const outerContainerStyle: Interpolation = {
  display: "flex",
  minHeight: "none",
  padding: spacing.ms,
  placeContent: "center",
  placeItems: "center",
  width: spacing.full,
  [cssMediaQueryMinWidthTablet]: {
    minHeight: "100dvh",
  },
};

const containerStyle: Interpolation<ThemeType> = (theme) => ({
  alignItems: "center",
  background: theme.semanticColors.background,
  borderRadius: radius.l,
  display: "flex",
  flexDirection: "column",
  gap: spacing.xl,
  justifyContent: "space-evenly",
  maxWidth: numericPixels[640],
  minHeight: numericPixels[360],
  paddingBottom: spacing.l,
  paddingLeft: spacing.l,
  paddingRight: spacing.l,
  paddingTop: spacing.l,
  position: "relative",
  width: "auto",
  zIndex: zIndices[1],
  [cssMediaQueryMinWidthTablet]: {
    paddingBottom: numericPixels[64],
    paddingLeft: spacing.xxl,
    paddingRight: spacing.xxl,
    paddingTop: numericPixels[64],
    width: "100dvw",
  },
});

type ParishFlowLayoutClientProps = {
  children?: ReactNode;
};

export const ParishFlowLayoutClient = ({
  children,
}: ParishFlowLayoutClientProps) => {
  return (
    <div css={outerContainerStyle}>
      <Image
        src={bgImg}
        alt={""}
        placeholder={"blur"}
        sizes={"100vw"}
        fill
        style={{ objectFit: "cover", objectPosition: "center" }}
      />
      <div css={containerStyle}>
        {children}
        <MobileDownloadLinksClient />
      </div>
    </div>
  );
};
